import { render } from "./ViewAllCatalogs.vue?vue&type=template&id=9dc72c7c&scoped=true&ts=true"
import script from "./ViewAllCatalogs.vue?vue&type=script&lang=ts"
export * from "./ViewAllCatalogs.vue?vue&type=script&lang=ts"

import "./ViewAllCatalogs.vue?vue&type=style&index=0&id=9dc72c7c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc72c7c"]])

export default __exports__